import { cn } from '@shared/utils/cn';

interface StatCardProps {
  label: string;
  value: number | string;
  tone?: 'default' | 'destructive' | 'sidebar' | 'success' | 'free';
  className?: string;
}

const toneClass: Record<NonNullable<StatCardProps['tone']>, string> = {
  default: 'text-foreground',
  destructive: 'text-destructive',
  sidebar: 'text-sidebar-primary',
  success: 'text-emerald-600',
  free: 'text-teal-600',
};

export function StatCard({ label, value, tone = 'default', className }: StatCardProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-1 px-4 py-3',
        className,
      )}
    >
      <span className={cn('text-3xl font-bold tracking-tight', toneClass[tone])}>{value}</span>
      <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
    </div>
  );
}
